import React from 'react';
import { Button, Checkbox, Dropdown, Form, Header, Loader, Tab, Table } from 'semantic-ui-react'
import EventRepo from '../../../utils/repository/eventRepo';
import { formatDateTimeUTC } from '../../../utils/dateTimeUtils';
import Alert from '../../../utils/alert';
import { getPaneCfg } from '../../../utils/general';
import { ISSUER_TYPE } from './constants';

class EventsLog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            peerRelatedEvents: [],
            nonPeerRelatedEvents: [],
            usersFilter: [],
            userOps: [],
            condensedFormat: false
        }
    }

    componentDidMount() {
        EventRepo.list(events => {
            events = events
                .sort(function (a, b) {
                    return new Date(a.uiDate) - new Date(b.uiDate);
                })
            {/* 
                Account for old events should be removed after the events (js logs) are deleted 
                and the issuer constant should be used instead of a string Peer Diff
            */}
            const peerRelatedEvents = events.filter(event => event.issuer.includes("Peer Diff"))
            const nonPeerRelatedEvents = events.filter(event => !event.issuer.includes("Peer Diff"))

            const users = Array.from(new Set(events.map(e => e.user)))
            const userOps = users.map(u => {
                return {
                    key: u,
                    text: u,
                    value: u
                }
            })

            this.setState({
                usersFilter: users, userOps, peerRelatedEvents, nonPeerRelatedEvents, loading:false
            })
        })
    }


    deleteAll = () => {
        EventRepo.deleteAll(() => {
            Alert.success("Deleted")
            this.setState({ peerRelatedEvents: [], nonPeerRelatedEvents:[]})
        })
    }

    isLoading() {
        return this.state.loading;
    }

    tabs() {
        return [
            getPaneCfg(
                'Events',
                <EventsTable
                    events={this.state.nonPeerRelatedEvents.filter((e) => this.state.usersFilter.includes(e.user))}
                    condensedFormat={this.state.condensedFormat}
                    deleteAll={this.deleteAll}
                />
            ),
            getPaneCfg(
                'Peer Events',
                <EventsTable
                    events={this.state.peerRelatedEvents.filter((e) => this.state.usersFilter.includes(e.user))}
                    condensedFormat={this.state.condensedFormat}
                    deleteAll={this.deleteAll}
                    issuer={ISSUER_TYPE.PEER_DIFF_RECONCILIATION_MONITOR}
                />
            ),
        ];
    }

    content() {
        return <>
            <Header as="h2" textAlign='center'>JS Events</Header>
            <Form.Field>
                <label>Users</label>
                <Dropdown
                    onChange={(a, b) => this.setState({ usersFilter: b.value })}
                    value={this.state.usersFilter}
                    placeholder='Users'
                    options={this.state.userOps} fluid multiple selection search />
            </Form.Field>
            <br />
            <Checkbox checked={this.state.condensedFormat}
                label="Condensed format"
                onChange={(evt, data) =>
                    this.setState({ condensedFormat: data.checked })
                } />
                <Tab panes={this.tabs()}/>
           
            
        </>
    }

    render() {
        return this.isLoading() ? <Loader /> : this.content();
    }
}

const PEER_PROPERTIES_TO_IGNORE = ['mainSchemaId', 'executedByUserId']

function Message({message, issuer}) {
    
    if(issuer === ISSUER_TYPE.PEER_DIFF_RECONCILIATION_MONITOR) {
        const peerDiffEvent = JSON.parse(message)
        return <>
            {/* Account for old events should be removed after the events (js logs) are deleted */}
            {Object.entries(peerDiffEvent.event ?? peerDiffEvent.acceptedEvent ?? peerDiffEvent.rejectedEvent)
            .filter(([key]) => !PEER_PROPERTIES_TO_IGNORE.includes(key))
            .map(([key, value]) => {
                return <p key={key}><b>{key}</b>: {value}</p>
            })}
        </>
    }else {
        return message
    }
}

function DetailedEventsTable({ events, issuer }) {
    return <Table celled className='jsEventsTable'>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>Message</Table.HeaderCell>
                <Table.HeaderCell>Stack</Table.HeaderCell>
                <Table.HeaderCell>Other</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {events
                .map(event => {
                    return <Table.Row key={event.id}>
                        <Table.Cell><Message message={event.message} issuer={issuer}/></Table.Cell>
                        <Table.Cell>{event.stack}</Table.Cell>
                        <Table.Cell>
                            <b>Issuer:</b>{event.issuer}<br />
                            <b>User:</b><span className='redFont'>{event.user}</span><br />
                            <b>Browser:</b>{event.browser}<br />
                            <b>Path:</b>{event.path}<br />
                            <b>Server Date UTC:</b>{event.date && formatDateTimeUTC(event.date)}<br />
                            <b>IU Date UTC:</b><span className='redFont'>{event.uiDate && formatDateTimeUTC(event.uiDate)}</span><br />
                            <b>Session ID:</b>{event.sessionId}<br />
                        </Table.Cell>
                    </Table.Row>
                })}
        </Table.Body>
    </Table>

}

function CondensedEventsTable({ events, issuer }) {
    const eventsMap = {}

    events.forEach(e => {
        const message = e.message
        if (eventsMap[message] === undefined) {
            eventsMap[message] = 0
        }
        eventsMap[message]++

    });
    const messages = [...new Set(events.map(e => e.message))]

    return <Table celled>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>Message</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {messages
                .map((message, idx) => {
                    return <Table.Row key={idx}>
                        <Table.Cell><Message message={message} issuer={issuer}/></Table.Cell>
                    </Table.Row>
                })}
        </Table.Body>
    </Table >
}

function EventsTable({ events, condensedFormat, deleteAll, issuer }) {
    if (!events.length) {
        return (
            <Header as="h4" textAlign="center">
                No Events Found
            </Header>
        );
    }

    return (
        <>
            {condensedFormat ? <CondensedEventsTable events={events} issuer={issuer} /> 
            : <DetailedEventsTable events={events} issuer={issuer}/>}
            <Button onClick={deleteAll} size="mini" color="red">
                Delete All
            </Button>
        </>
    );
}

export default EventsLog